// import { useRouter, type ReactNode } from '@tanstack/react-router';

import type { ReactNode } from 'react';

/**********************
 *
 * TODO: Merge this back into ht-sdk/react once we are happy with the design and behavior
 *
 * changes made:
 * - removed overflow-hidden from the table
 * - added overflow auto to the table container
 * - made table header sticky
 */

type TableHeadProps = {
	headers: string[];
};

export type TableProps = TableHeadProps & {
	className?: string;
	colWidths?: string[];
};

type RowProps = {
	rows: ReactNode[][];
};
// type LinkRowProps = {
// 	rows: { href: string; data: (string | ReactNode)[] }[];
// };

function TableRows({ rows }: RowProps) {
	return (
		<>
			{rows.map((row, index) => (
				<tr key={index} className={`${index % 2 == 0 ? '' : 'bg-gray-100 dark:bg-gray-800'}`}>
					{row.map((cell, i) => (
						<td key={i} className={'border-gray-200 p-3 dark:border-gray-700'}>
							{cell}
						</td>
					))}
				</tr>
			))}
		</>
	);
}

// function LinkTableRows({ rows }: LinkRowProps) {
// 	const router = useRouter();
// 	return (
// 		<>
// 			{rows.map((row, index) => (
// 				// use Link/to instead of href
// 				<tr key={index} onClick={() => router.navigate({ to: row.href })} className="cursor-pointer hover:bg-gray-100">
// 					{row.data.map((cell, i) => (
// 						<td key={i} className={'border-gray-200 p-3'}>
// 							{cell}
// 						</td>
// 					))}
// 				</tr>
// 			))}
// 		</>
// 	);
// }

function TableHead({ headers }: TableHeadProps) {
	return (
		<thead>
			<tr className="sticky top-0 border-b border-gray-100 bg-white text-gray-800 dark:border-gray-700 dark:text-gray-200">
				{headers.map((header, index) => (
					<th key={index} className="p-3 text-left">
						{header}
					</th>
				))}
			</tr>
		</thead>
	);
}

function TableFrame({ headers, rows, className = '', colWidths }: { rows: ReactNode } & TableProps) {
	return (
		<table
			className={`w-full border-collapse rounded-md bg-white text-sm text-gray-800 dark:bg-gray-900 dark:text-gray-300 ${className}`}
		>
			{colWidths && (
				<colgroup>
					{colWidths.map((w, i) => (
						<col key={i} style={{ width: w }} />
					))}
				</colgroup>
			)}
			{headers && <TableHead headers={headers} />}
			<tbody>{rows && rows}</tbody>
		</table>
	);
}

export function Table({ headers, rows, className = '', colWidths }: RowProps & TableProps) {
	return (
		<div className="overflow-auto rounded-lg border border-gray-200 dark:border-gray-700">
			<TableFrame headers={headers} rows={<TableRows rows={rows} />} className={className} colWidths={colWidths} />
		</div>
	);
}

// export function LinkTable({ headers, rows, className = '' }: LinkRowProps & TableProps) {
// 	return <TableFrame headers={headers} rows={<LinkTableRows rows={rows} />} className={className} />;
// }
